import React from "react";
import PropTypes from "prop-types";
import {Button} from "reactstrap";
import {FaUser} from "react-icons/all";
import BaseComponent from "../BaseComponent";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import UserDetailInformationModal from "../modal/UserDetailInformationModal";

export default class UserButton extends BaseComponent{

    constructor(props) {
        super(props);
        let state = this.state
        let user = this.props.user??{}
        state.userInformationModal = false
        state.user = user
        this.setState(state)
    }
    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let user = nextProps.user??{}
            this.setState({user})
        }
    }

    fetchUserInformation = (id) => {
        this.get(Endpoint.API.USER, {params:{
                id:id
            }}, null, response=>{
            if(response.code===200){
                let user = response.data
                this.setState({userInformationModal:true, user:user})
            }
        }, true, false)
    }

    render() {
        let {userInformationModal, user} = this.state
        let {onClick, style} = this.props
        if(!user){
            user = {}
        }
        let manufacturingSite = user.manufacturingSite??{}
        if(!onClick){
            onClick = (e) => {
                e.preventDefault()
                this.fetchUserInformation(user.id)
            }
        }
        if(!style){
            style = {}
        }

        return (
            <React.Fragment>
                {super.render()}
                <UserDetailInformationModal
                    user={user}
                    show={userInformationModal}
                    onClose={() => {
                        this.setState({userInformationModal:false})
                    }}/>
                <Button
                    style={{...style}}
                    className="btn-outline-orange btn-light"
                    variant="outline-info"
                    size="md"
                    onClick={onClick}>
                    <FaUser/>
                    &nbsp;
                    {user.firstname+(manufacturingSite.id?" / "+manufacturingSite.name:"")}
                </Button>
            </React.Fragment>
        );
    }

}
UserButton.propTypes = {
    user:PropTypes.object.isRequired,
    onClick:PropTypes.func,
    style:PropTypes.any
}
